import { defineStore } from 'pinia';
import CreateMailoutApi from '@/api';
import CONSTANT from '@/constant';
import { Holiday } from '@/types/delivery';
import { useTopbarStore } from '@/store/topbar';
import { DeliveryDraftData } from '@/types/myOrders';

const formatDateAsIso = (dateValue: Date): string => {
  const year = dateValue.getFullYear();
  const month = String(dateValue.getMonth() + 1).padStart(2, '0');
  const day = String(dateValue.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const normalizeSelectedDate = (dateValue: unknown): string => {
  if (typeof dateValue !== 'string') {
    return '';
  }
  const trimmedValue = dateValue.trim();
  return CONSTANT.DELIVERY.CALENDAR_DATE_FORMAT.test(trimmedValue) ? trimmedValue : '';
};

const useDeliveryStore = defineStore('delivery', {
  state: () => ({
    holidays: null as Holiday[] | null,
    selectedDate: '',
    range: '',
  }),
  actions: {
    setHolidays(holidays: Holiday[]) {
      this.holidays = holidays;
    },
    setSelectedDate(date: string) {
      const normalizedDate = normalizeSelectedDate(date);
      this.selectedDate = normalizedDate;
    },
    setRange(range: string) {
      this.range = range;
    },
    restoreFromDraft(data: DeliveryDraftData) {
      const normalizedDate = normalizeSelectedDate(data.selectedDate);
      this.selectedDate = normalizedDate;
      this.range = data.range || '';
    },
    async getHolidays(calendarYear?: number) {
      if (this.holidays !== null) {
        return;
      }
      const topbarStore = useTopbarStore();
      const endDateValue = new Date();
      if (typeof calendarYear === 'number') {
        endDateValue.setFullYear(calendarYear);
        endDateValue.setMonth(11);
        endDateValue.setDate(31);
      } else {
        endDateValue.setFullYear(endDateValue.getFullYear() + 1);
      }
      const requestData = {
        country: topbarStore.topBar?.market,
        language: topbarStore.topBar?.language,
        endDate: formatDateAsIso(endDateValue),
      };
      const response = await CreateMailoutApi.getHolidays(requestData);
      this.setHolidays(response.result);
    },
  },
});

export default useDeliveryStore;
